import type { BrowserEnvironment } from './environment.model';

export const environment = {
  environment: 'testing',
  production: false,
  apiBaseUrl: 'https://nabdbe.testing.gulfsquads.com',
  reverbBaseUrl: 'wss://nabdbe.testing.gulfsquads.com',
  hospitalTimeZone: 'Africa/Cairo',
  // Public identifier only. Realtime fails closed until deployment supplies it.
  reverbAppKey: '',
} as const satisfies BrowserEnvironment;
